/**
 * Heilmittelbereich as published by the GKV-Spitzenverband in the
 * Heilmittelpreisstammdatei (HMP). Closed set of five.
 *
 * The values are comma-free English keys, not the published names (ADR-0044).
 * TypeORM splits an enum column's `COLUMN_TYPE` at every comma when it reads
 * the schema, so a stored `Stimm-, Sprech-Sprach- und Schlucktherapie` made
 * `migration:generate` re-emit every column holding this enum. The keys match
 * the OCR checkbox ids (`heilmittelbereichPhysiotherapy` …).
 *
 * The two official spellings live in one mapping each, below:
 * `parseHeilmittelbereich` reads the HMP's, `heilmittelbereichLabel` writes the
 * contracts'. Anything a user reads goes through the label.
 *
 * The Bereich is part of the global catalogue identity — one Positionsnummer can
 * exist in two Bereiche at two prices (Podologie still bills `X9933` while
 * Physiotherapie renamed its `X9933` to `X9950` on 01.01.2026).
 */
export var Heilmittelbereich;
(function (Heilmittelbereich) {
    Heilmittelbereich["PHYSIOTHERAPY"] = "PHYSIOTHERAPY";
    Heilmittelbereich["OCCUPATIONAL_THERAPY"] = "OCCUPATIONAL_THERAPY";
    Heilmittelbereich["NUTRITION_THERAPY"] = "NUTRITION_THERAPY";
    Heilmittelbereich["SPEECH_THERAPY"] = "SPEECH_THERAPY";
    Heilmittelbereich["PODIATRY"] = "PODIATRY";
})(Heilmittelbereich || (Heilmittelbereich = {}));
/**
 * The HMP's own strings, verbatim — they are the join value against the
 * published file, not prose. That includes the source's spelling of
 * `Stimm-, Sprech-Sprach- und Schlucktherapie` (the contracts write
 * "Stimm-, Sprech-, Sprach- und Schlucktherapie"). Do not correct it here: an
 * import that no longer matches the file would silently drop a whole Bereich.
 */
const BY_HMP_SPELLING = new Map([
    ['Physiotherapie', Heilmittelbereich.PHYSIOTHERAPY],
    ['Ergotherapie', Heilmittelbereich.OCCUPATIONAL_THERAPY],
    ['Ernährungstherapie', Heilmittelbereich.NUTRITION_THERAPY],
    ['Stimm-, Sprech-Sprach- und Schlucktherapie', Heilmittelbereich.SPEECH_THERAPY],
    ['Podologie', Heilmittelbereich.PODIATRY],
]);
/**
 * Maps a raw Heilmittelbereich string from a published Stammdatei onto the enum.
 * Returns `undefined` for anything the closed set does not cover, so callers can
 * refuse the file loudly instead of persisting an unconstrained string.
 */
export function parseHeilmittelbereich(raw) {
    if (raw === null || raw === undefined)
        return undefined;
    return BY_HMP_SPELLING.get(raw.trim());
}
/** The Bereich as the §125 contracts name it. */
const LABELS = {
    [Heilmittelbereich.PHYSIOTHERAPY]: 'Physiotherapie',
    [Heilmittelbereich.OCCUPATIONAL_THERAPY]: 'Ergotherapie',
    [Heilmittelbereich.NUTRITION_THERAPY]: 'Ernährungstherapie',
    [Heilmittelbereich.SPEECH_THERAPY]: 'Stimm-, Sprech-, Sprach- und Schlucktherapie',
    [Heilmittelbereich.PODIATRY]: 'Podologie',
};
/** The name a user reads for a Bereich. */
export function heilmittelbereichLabel(bereich) {
    return LABELS[bereich];
}
//# sourceMappingURL=heilmittelbereich.enum.js.map